<template>
  <OnboardingQuestion :title="question" :disabled="!answer" @next="handleClick">
    <SelectOption v-model="answer" :icon="CalendarIcon" value="Every day">
      Every day
    </SelectOption>
    <SelectOption v-model="answer" :icon="CalendarIcon" value="Every week">
      Every week
    </SelectOption>
    <SelectOption v-model="answer" :icon="CalendarIcon" value="Every month">
      Every month
    </SelectOption>
    <SelectOption v-model="answer" :icon="CalendarIcon" value="A few times a year">
      A few times a year
    </SelectOption>
  </OnboardingQuestion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { CalendarIcon } from '@dacr/icons'

import OnboardingQuestion from '@/features/onboarding/components/OnboardingQuestion.vue'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'How often do you create?'

const answer = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Three] || '') as string
  },
  set(value: string) {
    onboardingStore.state[OnboardingStep.Three] = value
  },
})

const handleClick = () => {
  const answers = [answer.value]

  completeStep({ step: 3, question, answers })

  onboardingStore.goToNextStep({ question, answers })
}
</script>
